/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 12:11:32
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-04 12:41:50
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/slice/index.ts
 */
import { combineReducers } from '@reduxjs/toolkit';
import legalEditor from '../LegalPageEditor/slice';
import termsAndConditionEditor from '../TermsAndConditionEditor/slice';
const salesChannelLegalReducer = combineReducers({
  legalEditor,
  termsAndConditionEditor,
});
export default salesChannelLegalReducer;
export { EnumReducers } from './constants';
